import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
// import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import resourcesToBackend from 'i18next-resources-to-backend'
import _ from 'lodash'

import enUS from 'antd/es/locale/en_US'
import thTH from 'antd/es/locale/th_TH'

import moment from 'utils/moment'

export const defaultLanguage = 'en'

export const languages = [
  {
    key: 'en',
    momentKey: 'en',
    antdLocale: enUS,
  },
  {
    key: 'th',
    momentKey: 'th',
    antdLocale: thTH,
  },
]

export const languageCodes = languages.map((language) => language.key)

const changeLanguage = (key) => {
  const languageObj = _.find(languages, { key })
  moment.locale(languageObj.momentKey)
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(
    resourcesToBackend((language, namespace, callback) => {
      import(`../locales/${language}/${namespace}.json`)
        .then((resources) => {
          callback(null, resources)
        })
        .catch((error) => {
          callback(error, null)
        })
    })
  )
  .init({
    fallbackLng: defaultLanguage,
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    supportedLngs: languageCodes,
  })
  .then(() => {
    changeLanguage(i18n.language)
  })

i18n.on('languageChanged', function (lng) {
  changeLanguage(lng)
})

export default i18n
